// @flow

// eslint-disable-next-line
import type { Store } from 'redux';
import createDebugger from 'debug';

import type { Thunk } from 'types/redux';
import facebook from 'utils/oauth/FacebookOAuth';
import google from 'utils/oauth/GoogleOAuth';
import { SET_LOCALIZATION_STRING } from 'store/reducers/localizationString/actionTypes';
import socialActions from 'store/reducers/user/social/actions';

const debug = createDebugger('oauth:middleware');

type LocalizationStrings = {
  [string]: string
};

// prettier-ignore
const initializeOAuth =
  (i18n: LocalizationStrings): Thunk<Promise<void>> =>
  async (dispatch, getState) => {
    async function initializeFacebook() {
      await facebook.initialize(i18n['c8.social.facebook.clientid']);
      return facebook.getLoginStatus();
    }

    async function initializeGoogle() {
      await google.initialize(i18n['c8.social.google.clientid']);
      return google.getLoginStatus();
    }

    const [facebookStatus, googleStatus] = await Promise.all([
      initializeFacebook(),
      initializeGoogle()
    ]);
    debug(facebookStatus, googleStatus);

    // special logic to detect the initial sign in
    if (facebook.hasRedirectionFlag()) {
      facebook.setDoRedirection();
    }
    facebook.clearRedirectionFlag();

    dispatch(
      socialActions.providersInitialized({
        facebookStatus,
        googleStatus
      })
    );
  };

/**
 * OAuth middleware
 *
 * It waits for the localization initialization action to initialize the providers
 */
export const oauthMiddleware = (store: Store<any, any>) => (
  next: (action: any) => any
) => (action: any) => {
  // dispatches another action to initialize the providers
  if (action.type === SET_LOCALIZATION_STRING) {
    const result = next(action);
    // no need to store the result of this dispatch since
    // provider initialization is a no-op
    store.dispatch(initializeOAuth(action.payload));
    return result;
  }

  // forward un-intercepted action
  return next(action);
};



// WEBPACK FOOTER //
// ./src/store/middlewares/oauth.js